const customFullName = (value: { fullName: string | null } | string): string => {
	if (typeof value === "string") {
		return value;
	}
	if (value && "fullName" in value) {
		return String(value.fullName);
	}
	return "";
};

export { customFullName };
